export const currencyJsn = [
  {
    key: 'value',
    label: 'Currency Name',
    columnType: 'string',
  },
  {
    key: 'shorthand',
    label: 'Short Hand',
    columnType: 'string',
  },
];
